import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { VaultErrorBoundary } from './error-boundaries';

// Lazy load all page components
const Home = lazy(() => import('../pages/home'));
const Vaults = lazy(() => import('../pages/vaults'));
const VaultPage = lazy(() => import('../pages/vault-page'));
const VaultSettingsPage = lazy(() => import('../pages/vault-settings-page'));
const PeoplePage = lazy(() => import('../pages/vault-people-page'));
const PetsPage = lazy(() => import('../pages/vault-pets-page'));
const VehiclesPage = lazy(() => import('../pages/vault-vehicles-page'));
const PropertiesPage = lazy(() => import('../pages/vault-properties-page'));
const ProtectionPage = lazy(() => import('../pages/vault-protection-page'));
const SavingsPage = lazy(() => import('../pages/vault-savings-page'));
const LiabilitiesPage = lazy(() => import('../pages/vault-liabilities-page'));
const ItemsPage = lazy(() => import('../pages/vault-items-page'));
const IncomesPage = lazy(() => import('../pages/vault-incomes-page'));
const ExpendituresPage = lazy(() => import('../pages/vault-expenditures-page'));
const DebugPage = lazy(() => import('../pages/vault-debug-page'));

/**
 * Application routes component
 * Sync happens automatically via middleware when vault data changes
 */
export const VaultRoutes = () => {
  return (
    <Routes>
      {/* Landing page */}
      <Route path="/" element={<Home />} />
      
      {/* Vaults list page */}
      <Route path="/vaults" element={<Vaults />} />
      
      {/* Vault routes with error boundaries */}
      <Route path="/vaults/:vaultId" element={
        <VaultErrorBoundary>
          <VaultPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/settings" element={
        <VaultErrorBoundary>
          <VaultSettingsPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/incomes" element={
        <VaultErrorBoundary>
          <IncomesPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/expenditures" element={
        <VaultErrorBoundary>
          <ExpendituresPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/people" element={
        <VaultErrorBoundary>
          <PeoplePage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/pets" element={
        <VaultErrorBoundary>
          <PetsPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/vehicles" element={
        <VaultErrorBoundary>
          <VehiclesPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/properties" element={
        <VaultErrorBoundary>
          <PropertiesPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/protection" element={
        <VaultErrorBoundary>
          <ProtectionPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/savings" element={
        <VaultErrorBoundary>
          <SavingsPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/liabilities" element={
        <VaultErrorBoundary>
          <LiabilitiesPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/items" element={
        <VaultErrorBoundary>
          <ItemsPage />
        </VaultErrorBoundary>
      } />
      <Route path="/vaults/:vaultId/debug" element={
        <VaultErrorBoundary>
          <DebugPage />
        </VaultErrorBoundary>
      } />
    </Routes>
  );
};